import { SponsorForm } from "./form";

const CreateSponsor = () => {
  return <SponsorForm />;
};

export default CreateSponsor;
